import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AdminNavbar from "../Component/AdminNavbar";
export const AdminOrders = () => {

    const [orders, setOrders] = useState([]);
    const navigate = useNavigate();
    const updateStatus = async (id, status) => {

        const token = sessionStorage.getItem("token");

        await fetch(
            `${process.env.REACT_APP_API_URL}/order/status/${id}/${status}`,
            {
                method: "PUT",
                headers: {
                    Authorization: "Bearer " + token
                }
            }
        );

        loadOrders();
    };
    const loadOrders = async () => {
        try {
            const token = sessionStorage.getItem("token");
            console.log("TOKEN =", token);
            const res = await fetch(`${process.env.REACT_APP_API_URL}/order/all`, {
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            const data = await res.json();

            console.log("ORDERS =", data);

            setOrders(data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        loadOrders();
    }, []);

    return (
        <div className="container mt-5">

            <AdminNavbar />
            <h2>Admin Orders</h2>

            <table className="table table-bordered mt-4">
                <thead>
                <tr>
                    <th>Order ID</th>
                    <th>User Name</th>
                    <th>User Email</th>
                    <th>Amount</th>
                    <th>Payment ID</th>
                    <th>Payment Status</th>
                    <th>Order Status</th>
                    <th>Action</th>
                </tr>
                </thead>

                <tbody>
                {orders.map((order) => (
                    <tr key={order.orderId}>
                        <td>{order.orderId}</td>
                        <td>{order.user?.name}</td>
                        <td>{order.user?.email}</td>
                        <td>{order.totalAmount}</td>
                        <td>{order.paymentId}</td>
                        <td>{order.paymentStatus}</td>
                        <td>
                            <select
                                value={order.orderStatus}
                                onChange={(e) =>
                                    updateStatus(order.orderId, e.target.value)
                                }
                            >
                                <option value="PLACED">PLACED</option>
                                <option value="PROCESSING">PROCESSING</option>
                                <option value="SHIPPED">SHIPPED</option>
                                <option value="DELIVERED">DELIVERED</option>
                                <option value="CANCELLED">CANCELLED</option>
                            </select>
                        </td>
                        <td>
                            <button
                                className="btn btn-primary"
                                onClick={() => navigate(`/order-details/${order.orderId}`)}
                            >
                                View
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};